"use strict";

jQuery(document).ready(function ($) {
  var adpPopup = {};

  (function () {
    var $this;

    adpPopup = {
      sPrevious: window.scrollY,
      sDirection: "down",

      documentEventsBound: false,
      timers: {},
      animationTimeout: 700,
      animationEvents:
        "webkitAnimationEnd.adpPopup mozAnimationEnd.adpPopup MSAnimationEnd.adpPopup oanimationend.adpPopup animationend.adpPopup",

      /*
       * Initialize
       */
      init: function (e) {
        $this = adpPopup;

        // Init events.
        $this.events();

        // Wire the whole page on load, only the reloaded section afterwards.
        $this.popupInit(e && e.target ? e.target : document);
      },

      /*
       * Events
       */
      events: function () {
        if ($this.documentEventsBound) {
          return;
        }

        $this.documentEventsBound = true;

        // Set scroll direction.
        $(document).on("scroll.adpPopup", function () {
          let scrollCurrent = window.scrollY;

          $this.sDirection = scrollCurrent > $this.sPrevious ? "down" : "up";
          $this.sPrevious = scrollCurrent;
        });

        // Custom Events
        $(document).on("click.adpPopup", ".popup-close", $this.closePopup);
        $(document).on("click.adpPopup", ".popup-accept", $this.acceptPopup);
        $(document).on("click.adpPopup", ".popup-accept", $this.closePopup);
        $(document).on(
          "click.adpPopup",
          ".age-verification__popup-close",
          $this.agePopup
        );
        $(document).on(
          "click.adpPopup",
          ".age-verification__popup-close",
          $this.closePopup
        );
        $(document).on(
          "click.adpPopup",
          ".age-verification__button-no",
          $this.ageDeclined
        );

        // Checking this will cause popup to close when user presses key.
        $(document).on("keyup.adpPopup", function (e) {
          // Press ESC to Close.
          if (e.key === "Escape") {
            $('.popup-open[data-esc-close="true"]').each(function (
              index,
              popup
            ) {
              $this.closePopup(popup);
            });
          }

          // Press F4 to Close.
          if (e.key === "F4") {
            $('.popup-open[data-f4-close="true"]').each(function (
              index,
              popup
            ) {
              $this.closePopup(popup);
            });
          }
        });

        $(window).on("resize.adpPopup", function () {
          $this.setTimer("body-scroll-sync", $this.syncBodyScroll, 100);
        });

        // Checking this will cause popup to close when user clicks on overlay.
        $(document).on("click.adpPopup", ".popup-overlay", function () {
          $('.popup-open[data-overlay-close="true"]').each(function (
            index,
            popup
          ) {
            $this.closePopup(popup);
          });
        });
      },

      /*
       * Init popup elements
       */
      popupInit: function (scope) {
        $(scope || document)
          .find(".popup")
          .each(function (index, popup) {
            let $popup = $(popup);
            let namespace = $this.namespace(popup);

            $this.clearOpenTriggers(popup);
            $this.clearCloseTriggers(popup);

            // Manual Launch.
            if ("manual" === $popup.data("open-trigger")) {
              let selector = $popup.data("open-manual-selector");

              if (selector) {
                $(selector).addClass("popup-trigger");

                $(document)
                  .off("click.adpPopupTrigger" + namespace)
                  .on(
                    "click.adpPopupTrigger" + namespace,
                    selector,
                    function (e) {
                      e.preventDefault();

                      // A trigger placed inside a popup closes it first.
                      let $origin = $(e.currentTarget).closest(".popup");

                      if ($origin.length) {
                        $this.closePopup($origin);
                      }

                      // A manual trigger may always reopen its popup.
                      $popup.removeClass("popup-already-opened");

                      $this.openPopup(popup);
                    }
                  );
              }
            }

            // Checks whether a popup should be displayed or not.
            if (
              !$this.isAllowPopup(popup) &&
              !$popup.hasClass("age-verification")
            ) {
              return;
            }

            $this.openTriggerPopup(popup);
          });
      },

      /*
       * Trigger open popup
       */
      openTriggerPopup: function (e) {
        let popup = e.originalEvent ? this : e;
        let $popup = $(popup);
        let namespace = $this.namespace(popup);

        var trigger = $popup.data("open-trigger");

        // Drop the triggers left over by a previous init of this popup.
        $this.clearOpenTriggers(popup);

        // Age Verification.
        if ("none" === trigger) {
          let ageVerification = $this.getStorage(
            "popup-age-" + ($popup.data("id") || 0)
          );

          if (!ageVerification) $this.openPopup(popup);
        }

        // Time Delay.
        if ("delay" === trigger) {
          $this.setTimer(
            namespace + "-open",
            function () {
              $this.openPopup(popup);
            },
            $popup.data("open-delay-number") * 1000
          );
        }

        // Exit Intent.
        if ("exit" === trigger) {
          $(document).on("mousemove.adpPopupOpen" + namespace, function (e) {
            // Get current scroll position
            var scroll =
              window.pageYOffset || document.documentElement.scrollTop;

            if (e.pageY - scroll >= 7) {
              return;
            }

            // An open trigger must fire once, unbind before opening.
            $(document).off("mousemove.adpPopupOpen" + namespace);

            $this.openPopup(popup);
          });
        }

        // Scroll Position.
        if ("scroll" === trigger) {
          var pointScrollType = $popup.data("open-scroll-type");
          var pointScrollPosition = $popup.data("open-scroll-position");

          // Event scroll.
          $(document).on("scroll.adpPopupOpen" + namespace, function () {
            var reached =
              "px" === pointScrollType
                ? window.scrollY >= pointScrollPosition
                : $this.getScrollPercent() >= pointScrollPosition;

            if (!reached) {
              return;
            }

            // An open trigger must fire once, unbind before opening.
            $(document).off("scroll.adpPopupOpen" + namespace);

            $this.openPopup(popup);
          });
        }

        // Accept Agreement.
        if ("accept" === trigger) {
          let accept = $this.getStorage(
            "popup-accept-" + ($popup.data("id") || 0)
          );

          if (!accept) {
            $this.openPopup(popup);
          }
        }
      },

      /*
       * Trigger close popup
       */
      closeTriggerPopup: function (e) {
        let popup = e.originalEvent ? this : e;
        let $popup = $(popup);
        let namespace = $this.namespace(popup);

        var trigger = $popup.data("close-trigger");

        // Drop the triggers of the previous open cycle.
        $this.clearCloseTriggers(popup);

        // Time Delay.
        if ("delay" === trigger) {
          $this.setTimer(
            namespace + "-close",
            function () {
              $this.closePopup(popup);
            },
            $popup.data("close-delay-number") * 1000
          );
        }

        // Scroll Position.
        if ("scroll" === trigger) {
          var pointScrollType = $popup.data("close-scroll-type");
          var pointScrollPosition = $popup.data("close-scroll-position");
          var initScrollPx = $popup.data("init-scroll-px");
          var initScrollPercent = $popup.data("init-scroll-percent");

          // Event scroll.
          $(document).on("scroll.adpPopupClose" + namespace, function () {
            // Type px.
            if ("px" === pointScrollType) {
              if (
                "up" === $this.sDirection &&
                window.scrollY < initScrollPx - pointScrollPosition
              ) {
                $this.closePopup(popup);
              }

              if (
                "down" === $this.sDirection &&
                window.scrollY >= initScrollPx + pointScrollPosition
              ) {
                $this.closePopup(popup);
              }
            }

            // Type %.
            if ("%" === pointScrollType) {
              if (
                "up" === $this.sDirection &&
                $this.getScrollPercent() <
                  initScrollPercent - pointScrollPosition
              ) {
                $this.closePopup(popup);
              }

              if (
                "down" === $this.sDirection &&
                $this.getScrollPercent() >=
                  initScrollPercent + pointScrollPosition
              ) {
                $this.closePopup(popup);
              }
            }
          });
        }
      },

      /*
       * Open popup
       */
      openPopup: function (e) {
        let popup = e.originalEvent ? this : e;
        let $popup = $(popup);

        // Nothing to open.
        if (!$popup.length) {
          return;
        }

        if ($popup.hasClass("popup-open")) {
          return;
        }

        // Check already opened.
        if ($popup.hasClass("popup-already-opened")) {
          return;
        }

        // A popup opens once per trigger, drop what is still pending.
        $this.clearOpenTriggers(popup);

        // Display popup.
        $popup.addClass("popup-open");

        // Hide body scroll.
        $this.syncBodyScroll();

        // Set local storage of Limit display.
        let limit =
          parseInt($this.getStorage("popup-" + $popup.data("id")) || 0, 10) + 1;

        $this.setStorage("popup-" + $popup.data("id"), limit, {
          expires: $popup.data("limit-lifetime"),
        });

        // Set current scroll.
        $popup.data("init-scroll-px", window.scrollY);
        $popup.data("init-scroll-percent", $this.getScrollPercent());

        // Open animation.
        let animation = $popup.data("open-animation");

        $this.applyAnimation(popup, animation);

        // Init close trigger.
        $this.closeTriggerPopup(popup);
      },

      /*
       * Age popup
       */
      agePopup: function (e) {
        let $el = e.originalEvent ? this : e;

        // Get popup container.
        let popup = $($el).closest(".popup");

        // Set local storage of Age.
        $this.setStorage("popup-age-" + $(popup).data("id"), 1, {
          expires: 360,
        });
      },

      /*
       * Age declined
       */

      ageDeclined: function () {
        $(".age-verification__question").removeClass("show");
        $(".age-verification__declined").addClass("show");
      },

      /*
       * Accept popup
       */
      acceptPopup: function (e) {
        let $el = e.originalEvent ? this : e;

        // Get popup container.
        let popup = $($el).closest(".popup");

        // Set local storage of Accept.
        $this.setStorage("popup-accept-" + $(popup).data("id"), 1, {
          expires: 360,
        });
      },

      /*
       * Close popup
       */
      closePopup: function (e) {
        let $el = e.originalEvent ? this : e;

        // Get popup container.
        let $popup = $($el).closest(".popup");

        // Nothing to close.
        if (!$popup.length || !$popup.hasClass("popup-open")) {
          return;
        }

        $this.clearOpenTriggers($popup);
        $this.clearCloseTriggers($popup);
        $popup.addClass("popup-already-opened popup-closing");

        // Remove classes from body.
        $this.syncBodyScroll();

        // Close animation.
        let animation = $popup.data("exit-animation");

        $this.applyAnimation($popup, animation, function () {
          // Hide popup.
          $popup.removeClass("popup-open popup-closing");
        });
      },

      /*
       * Keep the body lock in sync with the popups that are really open
       */
      syncBodyScroll: function () {
        let locked = $('.popup.popup-open[data-body-scroll-disable="true"]')
          .not(".popup-closing")
          .filter(function () {
            // A popup hidden by `data-mobile-disable` must never lock the body,
            // its close button cannot be reached.
            return "none" !== $(this).css("display");
          }).length;

        $("body").toggleClass("popup-scroll-hidden", locked > 0);
      },

      /*
       * Build a unique event namespace for a popup
       */
      namespace: function (popup) {
        let id = $(popup).data("id") || $(popup).attr("id") || "shared";

        return String(id).replace(/[^a-zA-Z0-9]/g, "");
      },

      /*
       * Remove every pending open trigger of a popup
       */
      clearOpenTriggers: function (popup) {
        let namespace = $this.namespace(popup);

        $this.clearTimer(namespace + "-open");

        $(document).off("scroll.adpPopupOpen" + namespace);
        $(document).off("mousemove.adpPopupOpen" + namespace);
      },

      /*
       * Remove every pending close trigger of a popup
       */
      clearCloseTriggers: function (popup) {
        let namespace = $this.namespace(popup);

        $this.clearTimer(namespace + "-close");

        $(document).off("scroll.adpPopupClose" + namespace);
      },

      /*
       * Set timer
       */
      setTimer: function (key, handler, delay) {
        $this.clearTimer(key);

        $this.timers[key] = setTimeout(function () {
          delete $this.timers[key];

          handler();
        }, delay);
      },

      /*
       * Clear timer
       */
      clearTimer: function (key) {
        if (!$this.timers[key]) {
          return;
        }

        clearTimeout($this.timers[key]);

        delete $this.timers[key];
      },

      /*
       * Checks whether a popup should be displayed or not
       */
      isAllowPopup: function (e) {
        let popup = e.originalEvent ? this : e;

        // Has user seen this popup before?
        let limitDisplay = parseInt($(popup).data("limit-display") || 0);

        let limitDisplayCookie = parseInt(
          $this.getStorage("popup-" + $(popup).data("id"))
        );

        if (
          limitDisplay &&
          limitDisplayCookie &&
          limitDisplayCookie >= limitDisplay
        ) {
          return;
        }

        return true;
      },

      /*
       * Apply animation
       */
      applyAnimation: function (el, name, callback) {
        let $popup = $(el).closest(".popup");
        let $wrap = $popup.find(".popup-wrap");
        let $overlay = $popup.next(".popup-overlay");

        if (typeof callback === "function") {
          var overlayName = "popupExitFade";
        } else {
          var overlayName = "popupOpenFade";
        }

        let token = ($popup.data("animation-token") || 0) + 1;

        $popup.data("animation-token", token);

        let finish = function () {
          if ($popup.data("animation-token") !== token) {
            return;
          }

          $popup.removeData("animation-token");
          $this.clearAnimation($wrap);
          $this.clearAnimation($overlay);

          if (typeof callback === "function") {
            callback();
          }
        };

        // Overlay Animation.
        $this
          .clearAnimation($overlay)
          .addClass("popup-animated " + overlayName);

        // Wrap Animation.
        $this.clearAnimation($wrap);

        if ($wrap.length) {
          // Force a reflow, so an interrupted animation restarts.
          void $wrap[0].offsetWidth;
        }

        if (name) {
          $wrap
            .addClass("popup-animated " + name)
            .one($this.animationEvents, finish);
        }

        setTimeout(finish, $this.animationTimeout);
      },

      /*
       * Remove the animation classes and listeners of an element
       */
      clearAnimation: function (el) {
        return $(el)
          .off($this.animationEvents)
          .removeClass(function (index, className) {
            return (className || "")
              .split(/\s+/)
              .filter(function (name) {
                return (
                  "popup-animated" === name ||
                  0 === name.indexOf("popupOpen") ||
                  0 === name.indexOf("popupExit")
                );
              })
              .join(" ");
          });
      },

      /*
       * Set cookie
       */
      getCookie: function (name) {
        var matches = document.cookie.match(
          new RegExp(
            "(?:^|; )" +
              name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
              "=([^;]*)"
          )
        );
        return matches ? decodeURIComponent(matches[1]) : undefined;
      },

      /*
       * Set cookie
       */
      setCookie: function (name, value, options) {
        options = options || {};

        options.path = options.hasOwnProperty("path") ? options.path : "/";

        options.expires = parseInt(options.expires);

        if (typeof options.expires == "number" && options.expires) {
          options.expires = new Date().setDate(
            new Date().getDate() + options.expires
          );

          options.expires = new Date(options.expires).toUTCString();
        }

        value = encodeURIComponent(value);

        var updatedCookie = name + "=" + value;

        for (var propName in options) {
          updatedCookie += "; " + propName;
          var propValue = options[propName];
          if (propValue !== true) {
            updatedCookie += "=" + propValue;
          }
        }

        document.cookie = updatedCookie;
      },

      /*
       * Get local storage
       */
      getStorage: function (key) {
        const item = localStorage.getItem(key);
        if (!item) return undefined;

        try {
          const parsed = JSON.parse(item);
          if (parsed.expires && Date.now() > parsed.expires) {
            localStorage.removeItem(key);
            return undefined;
          }
          return parsed.value;
        } catch {
          return undefined;
        }
      },

      /*
       * Set local storage
       */
      setStorage: function (key, value, options = {}) {
        const data = {
          value,
          expires: null,
        };
        if (options.expires) {
          const expiresDate = new Date();
          expiresDate.setDate(
            expiresDate.getDate() + parseInt(options.expires, 10)
          );
          data.expires = expiresDate.getTime();
        }
        localStorage.setItem(key, JSON.stringify(data));
      },

      /*
       * Get scroll percent
       */
      getScrollPercent: function () {
        var h = document.documentElement,
          b = document.body,
          st = "scrollTop",
          sh = "scrollHeight";
        return ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100;
      },
    };
  })();

  // Initialize.
  adpPopup.init();

  document.addEventListener("shopify:section:load", function (e) {
    adpPopup.init(e);
  });

  // Drop everything a removed section left behind, so no timer or listener can
  // reach a detached popup.
  document.addEventListener("shopify:section:unload", function (e) {
    $(e.target)
      .find(".popup")
      .each(function (index, popup) {
        adpPopup.clearOpenTriggers(popup);
        adpPopup.clearCloseTriggers(popup);

        $(document).off("click.adpPopupTrigger" + adpPopup.namespace(popup));
      });

    // Runs once the section is really detached.
    setTimeout(adpPopup.syncBodyScroll, 0);
  });
});
